import { render } from "./Script.vue?vue&type=template&id=d7df152e&scoped=true"
import script from "./Script.vue?vue&type=script&lang=js"
export * from "./Script.vue?vue&type=script&lang=js"

import "./Script.vue?vue&type=style&index=0&id=d7df152e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/vertex/vertex/webui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7df152e"]])

export default __exports__